<template>
  <div class="container-fluid mt-3 bg-white my-5 p-5">
    <h1 class="text-uppercase font-basetheme font-kanit text-center py-3">PRODUCT</h1>
    <div class="colunm-border-bottom w-100 m-auto"></div>
    <div class="row my-5">
      <div class="col-md-3">
        <div class="card shadow rounded-0" style="min-height: 30rem; position: relative">
          <img src="@/assets/img/product/ivfthailand.png" class="card-img-top rounded-0" alt="..." />
          <div class="card-body">
            <h5 class="card-title font-secondtheme">IVF Thailand</h5>
            <p
              class="card-text font-grey"
            >บริษัท ไอวีเอฟ (ไทยแลน์) จำกัด เป็นผู้ให้บริการการรักษาภาวะมีบุตรยากที่ได้รับมาตรฐานและ ทันสมัย ด้วยการบริการในระดับพรีเมี่ยม เพียบพร้อมด้วยการบริการต่างๆ แบบครบวงจร และให้คำปรึกษา และรักษาภาวะมีบุตรยาก เช่น การฉีดน้ำเชื้อเข้าสู่โพรงมดลูก (IUI)</p>
          </div>
          <div class="card-footer">
            <a
              href="http://www.ivfthailand.co/"
              target="_blank"
              class="btn bg-basetheme font-white hover d-block rounded-0"
            >Go to project</a>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card shadow rounded-0" style="min-height: 30rem; position: relative">
          <img src="@/assets/img/product/tiethai.png" class="card-img-top rounded-0" alt="..." />
          <div class="card-body">
            <h5 class="card-title font-secondtheme">TieThai</h5>
            <p
              class="card-text font-grey"
            >TieThai EVOA Website, TieThai is the officially authorized partner with VFS to services for E-Visa on Arrival (E-VOA). Chinese people can save time at immigration by applying E-VOA using TieThai Mini Application in WeChat.</p>
          </div>
          <div class="card-footer">
            <a
              href="https://tiethai.app/"
              target="_blank"
              class="btn bg-basetheme font-white hover d-block rounded-0"
            >Go to project</a>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card shadow rounded-0" style="min-height: 30rem; position: relative">
          <img src="@/assets/img/product/tieloa.png" class="card-img-top rounded-0" alt="..." />
          <div class="card-body">
            <h5 class="card-title font-secondtheme">TieLao</h5>
            <p
              class="card-text font-grey"
            >TieLao EVOA Website, TieLao is the officially authorized partner with LGW Lao Gateway to services for eVisa. Chinese people can save time at immigration by applying eVisa using TieLao Mini Application in WeChat.</p>
          </div>
          <div class="card-footer">
            <a
              href="https://tielao.app/"
              target="_blank"
              class="btn bg-basetheme font-white hover d-block rounded-0"
            >Go to project</a>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card shadow rounded-0" style="min-height: 30rem; position: relative">
          <img src="@/assets/img/product/dmcr.png" class="card-img-top rounded-0" alt="..." />
          <div class="card-body">
            <h5 class="card-title font-secondtheme">GIS for Government</h5>
            <p
              class="card-text font-grey"
            >TieThai EVOA Website, TieThai is the officially authorized partner with VFS to services for E-Visa on Arrival (E-VOA). Chinese people can save time at immigration by applying E-VOA using TieThai Mini Application in WeChat.</p>
          </div>
          <div class="card-footer">
            <a
              href="https://mgris.dmcr.go.th/"
              target="_blank"
              class="btn bg-basetheme font-white hover d-block rounded-0"
            >Go to project</a>
          </div>
        </div>
      </div>
    </div>
    <div class="colunm-border-bottom w-100 m-auto"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>